// The browser player's origin, resolved per environment.
//
// Three surfaces send an operator to the web player: the Screens page and the
// Dashboard toolbar buttons (next to Quick Add), and the Add-Screen wizard's
// "Open web.wetook.net" step. All three used to hardcode
// https://web.wetook.net, so a staging dashboard handed the operator the
// PRODUCTION player — pairing a staging screen there can never work, because
// the code it shows is issued by a different backend.
//
// Resolution order:
//   1. VITE_WEBPLAYER_URL from the app's committed .env.[mode] (the same
//      convention as VITE_FRAME_URL / VITE_MY_URL — see Sidebar's APP_URLS).
//   2. Derived from the dashboard's OWN hostname, so a build that somehow
//      shipped without the env var still stays inside its environment
//      (frame.staging.wetook.net → web.staging.wetook.net).
//   3. Production, as the final fallback.
const ENV_URL = ((import.meta as any).env?.VITE_WEBPLAYER_URL as string || '').replace(/\/$/, '')

function fromHostname(): string {
  if (typeof window === 'undefined') return ''
  const h = window.location.hostname
  // frame.staging.wetook.net → web.staging.wetook.net (and any other
  // *.staging.wetook.net dashboard host).
  if (h.endsWith('.staging.wetook.net')) return 'https://web.staging.wetook.net'
  if (h.endsWith('.wetook.net')) return 'https://web.wetook.net'
  return ''
}

/** Full origin of the web player for this environment, no trailing slash. */
export const WEB_PLAYER_URL = ENV_URL || fromHostname() || 'https://web.wetook.net'

/** Host only — what the wizard prints so the operator can type it on the TV
 *  ("Open web.staging.wetook.net on any browser"). */
export const WEB_PLAYER_HOST = WEB_PLAYER_URL.replace(/^https?:\/\//, '')
